import angular from 'angular';

import CardWithPeriodComponent from './card-with-period.cmpt';

export default angular
    .module('application.scene.authorized.scene.dashboard.component.card-with-period', [])
    .component(CardWithPeriodComponent.selector, CardWithPeriodComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/card-with-period/index.js